import { functionDoc } from '../functionDoc';
import { ROLES, SHOTS } from '../docHelpers';

/** Documentación detallada (plantilla 12 apartados) — módulo Producción. */
export const produccionSections = [
  functionDoc({
    id: "prod-inicio",
    name: "Inicio Producción",
    type: "screen",
    route: "/produccion",
    locationPath: "Producción > Inicio",
    generalDescription: "Panel de acceso rápido a recetas, guías PT/PEP, líneas y reportes del módulo de producción general.",
    prerequisites: [
      "Módulo Producción habilitado.",
      "Recetas y clasificación configuradas.",
      "Almacenes de insumo y PT definidos en guías."
    ],
    interfaceElements: [
      {
        "name": "Enlaces de módulo",
        "controlType": "Tarjetas",
        "required": false,
        "editable": true,
        "automatic": true,
        "description": "Atajos a funciones principales.",
        "behavior": ""
      }
    ],
    procedure: [
      "Menú Producción.",
      "Elija la función deseada."
    ],
    practicalExample: "Planificador abre guías PT del día.",
    validations: [
      "Visible solo con módulo Producción activo."
    ],
    expectedResult: [
      "Navegación al submódulo correcto."
    ],
    commonErrors: [
      {
        "error": "Receta sin insumos",
        "cause": "Ficha incompleta o producto inactivo.",
        "solution": "Complete la ficha de receta antes de producir."
      },
      {
        "error": "Stock insuficiente de insumo",
        "cause": "Saldo en almacén de explosión menor al requerido.",
        "solution": "Ingrese mercadería o reduzca cantidad a producir."
      }
    ],
    relatedFunctions: [
      "prod-guias-hub",
      "prod-recetas-list"
    ],
    observations: [ROLES.limitado, "Las guías de producción afectan kardex de insumos y productos elaborados."],
    screenshots: [SHOTS.vistaGeneral],
    roles: ROLES.produccion,
  }),
  functionDoc({
    id: "prod-clasif-categorias",
    name: "Clasificación — categorías",
    type: "config",
    route: "/produccion/clasificacion-recetas/categorias",
    locationPath: "Producción > Clasificación recetas > Categorías",
    generalDescription: "Primer nivel de la jerarquía de recetas: agrupa subcategorías y fichas para reportes y filtros.",
    prerequisites: [
      "Módulo Producción habilitado.",
      "Recetas y clasificación configuradas.",
      "Almacenes de insumo y PT definidos en guías."
    ],
    interfaceElements: [
      {
        "name": "Nombre y código",
        "controlType": "Campo",
        "required": true,
        "editable": true,
        "automatic": false,
        "description": "Identificador de la clasificación.",
        "behavior": ""
      },
      {
        "name": "Guardar",
        "controlType": "Botón",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Persiste el catálogo.",
        "behavior": ""
      }
    ],
    procedure: [
      "Producción → Clasificación de recetas.",
      "Abra Categorías.",
      "Cree o edite registros.",
      "Guarde y verifique en jerarquía."
    ],
    practicalExample: "Mantenga categorías alineado al catálogo de productos.",
    validations: [
      "No elimine nodos usados en recetas activas sin reasignar."
    ],
    expectedResult: [
      "Catálogo actualizado para fichas de receta."
    ],
    commonErrors: [
      {
        "error": "Receta sin insumos",
        "cause": "Ficha incompleta o producto inactivo.",
        "solution": "Complete la ficha de receta antes de producir."
      },
      {
        "error": "Stock insuficiente de insumo",
        "cause": "Saldo en almacén de explosión menor al requerido.",
        "solution": "Ingrese mercadería o reduzca cantidad a producir."
      }
    ],
    relatedFunctions: [
      "prod-recetas-list",
      "prod-recetas-form"
    ],
    observations: [ROLES.limitado, "Las guías de producción afectan kardex de insumos y productos elaborados."],
    screenshots: [SHOTS.listado],
    roles: ROLES.produccion,
  }),
  functionDoc({
    id: "prod-clasif-subcategorias",
    name: "Clasificación — subcategorías",
    type: "config",
    route: "/produccion/clasificacion-recetas/subcategorias",
    locationPath: "Producción > Clasificación recetas > Subcategorías",
    generalDescription: "Segundo nivel bajo categoría; organiza familias y recetas en plantas de alimentos o manufactura.",
    prerequisites: [
      "Módulo Producción habilitado.",
      "Recetas y clasificación configuradas.",
      "Almacenes de insumo y PT definidos en guías."
    ],
    interfaceElements: [
      {
        "name": "Nombre y código",
        "controlType": "Campo",
        "required": true,
        "editable": true,
        "automatic": false,
        "description": "Identificador de la clasificación.",
        "behavior": ""
      },
      {
        "name": "Guardar",
        "controlType": "Botón",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Persiste el catálogo.",
        "behavior": ""
      }
    ],
    procedure: [
      "Producción → Clasificación de recetas.",
      "Abra Subcategorías.",
      "Cree o edite registros.",
      "Guarde y verifique en jerarquía."
    ],
    practicalExample: "Mantenga subcategorías alineado al catálogo de productos.",
    validations: [
      "No elimine nodos usados en recetas activas sin reasignar."
    ],
    expectedResult: [
      "Catálogo actualizado para fichas de receta."
    ],
    commonErrors: [
      {
        "error": "Receta sin insumos",
        "cause": "Ficha incompleta o producto inactivo.",
        "solution": "Complete la ficha de receta antes de producir."
      },
      {
        "error": "Stock insuficiente de insumo",
        "cause": "Saldo en almacén de explosión menor al requerido.",
        "solution": "Ingrese mercadería o reduzca cantidad a producir."
      }
    ],
    relatedFunctions: [
      "prod-recetas-list",
      "prod-recetas-form"
    ],
    observations: [ROLES.limitado, "Las guías de producción afectan kardex de insumos y productos elaborados."],
    screenshots: [SHOTS.listado],
    roles: ROLES.produccion,
  }),
  functionDoc({
    id: "prod-clasif-familias",
    name: "Clasificación — familias",
    type: "config",
    route: "/produccion/clasificacion-recetas/familias",
    locationPath: "Producción > Clasificación recetas > Familias",
    generalDescription: "Agrupación fina antes de la ficha; útil para márgenes y reportes de uso de insumo.",
    prerequisites: [
      "Módulo Producción habilitado.",
      "Recetas y clasificación configuradas.",
      "Almacenes de insumo y PT definidos en guías."
    ],
    interfaceElements: [
      {
        "name": "Nombre y código",
        "controlType": "Campo",
        "required": true,
        "editable": true,
        "automatic": false,
        "description": "Identificador de la clasificación.",
        "behavior": ""
      },
      {
        "name": "Guardar",
        "controlType": "Botón",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Persiste el catálogo.",
        "behavior": ""
      }
    ],
    procedure: [
      "Producción → Clasificación de recetas.",
      "Abra Familias.",
      "Cree o edite registros.",
      "Guarde y verifique en jerarquía."
    ],
    practicalExample: "Mantenga familias alineado al catálogo de productos.",
    validations: [
      "No elimine nodos usados en recetas activas sin reasignar."
    ],
    expectedResult: [
      "Catálogo actualizado para fichas de receta."
    ],
    commonErrors: [
      {
        "error": "Receta sin insumos",
        "cause": "Ficha incompleta o producto inactivo.",
        "solution": "Complete la ficha de receta antes de producir."
      },
      {
        "error": "Stock insuficiente de insumo",
        "cause": "Saldo en almacén de explosión menor al requerido.",
        "solution": "Ingrese mercadería o reduzca cantidad a producir."
      }
    ],
    relatedFunctions: [
      "prod-recetas-list",
      "prod-recetas-form"
    ],
    observations: [ROLES.limitado, "Las guías de producción afectan kardex de insumos y productos elaborados."],
    screenshots: [SHOTS.listado],
    roles: ROLES.produccion,
  }),
  functionDoc({
    id: "prod-clasif-jerarquia",
    name: "Clasificación — jerarquía",
    type: "config",
    route: "/produccion/clasificacion-recetas/jerarquia",
    locationPath: "Producción > Clasificación recetas > Jerarquía",
    generalDescription: "Vista en árbol de categoría → subcategoría → familia → receta para auditoría del catálogo.",
    prerequisites: [
      "Módulo Producción habilitado.",
      "Recetas y clasificación configuradas.",
      "Almacenes de insumo y PT definidos en guías."
    ],
    interfaceElements: [
      {
        "name": "Nombre y código",
        "controlType": "Campo",
        "required": true,
        "editable": true,
        "automatic": false,
        "description": "Identificador de la clasificación.",
        "behavior": ""
      },
      {
        "name": "Guardar",
        "controlType": "Botón",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Persiste el catálogo.",
        "behavior": ""
      }
    ],
    procedure: [
      "Producción → Clasificación de recetas.",
      "Abra Jerarquía.",
      "Cree o edite registros.",
      "Guarde y verifique en jerarquía."
    ],
    practicalExample: "Mantenga jerarquía alineado al catálogo de productos.",
    validations: [
      "No elimine nodos usados en recetas activas sin reasignar."
    ],
    expectedResult: [
      "Catálogo actualizado para fichas de receta."
    ],
    commonErrors: [
      {
        "error": "Receta sin insumos",
        "cause": "Ficha incompleta o producto inactivo.",
        "solution": "Complete la ficha de receta antes de producir."
      },
      {
        "error": "Stock insuficiente de insumo",
        "cause": "Saldo en almacén de explosión menor al requerido.",
        "solution": "Ingrese mercadería o reduzca cantidad a producir."
      }
    ],
    relatedFunctions: [
      "prod-recetas-list",
      "prod-recetas-form"
    ],
    observations: [ROLES.limitado, "Las guías de producción afectan kardex de insumos y productos elaborados."],
    screenshots: [SHOTS.listado],
    roles: ROLES.produccion,
  }),
  functionDoc({
    id: "prod-recetas-list",
    name: "Fichas de receta — listado",
    type: "list",
    route: "/produccion/clasificacion-recetas/recetas",
    locationPath: "Producción > Recetas > Fichas de receta",
    generalDescription: "Listado de fichas técnicas: insumos, cantidades, rendimiento y tipo de salida (PT o PEP). Base para guías de producción y reporte de uso de insumo.",
    prerequisites: [
      "Módulo Producción habilitado.",
      "Recetas y clasificación configuradas.",
      "Almacenes de insumo y PT definidos en guías."
    ],
    interfaceElements: [
      {
        "name": "Filtros",
        "controlType": "Filtros",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Por clasificación o texto.",
        "behavior": ""
      },
      {
        "name": "Tabla recetas",
        "controlType": "Tabla",
        "required": false,
        "editable": true,
        "automatic": true,
        "description": "Nombre, salida, estado.",
        "behavior": ""
      },
      {
        "name": "Nueva receta",
        "controlType": "Botón",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Abre formulario vacío.",
        "behavior": ""
      }
    ],
    procedure: [
      "Producción → Clasificación recetas → Fichas.",
      "Filtre si necesita.",
      "Edite o cree receta."
    ],
    practicalExample: {
      "context": "Buscar receta de pan ciabatta.",
      "steps": [
        "Filtre familia panes",
        "Abra ficha"
      ]
    },
    validations: [
      "Receta inactiva no aparece en guías nuevas."
    ],
    expectedResult: [
      "Catálogo de recetas mantenible."
    ],
    commonErrors: [
      {
        "error": "Receta sin insumos",
        "cause": "Ficha incompleta o producto inactivo.",
        "solution": "Complete la ficha de receta antes de producir."
      },
      {
        "error": "Stock insuficiente de insumo",
        "cause": "Saldo en almacén de explosión menor al requerido.",
        "solution": "Ingrese mercadería o reduzca cantidad a producir."
      }
    ],
    relatedFunctions: [
      "prod-recetas-form",
      "prod-guia-pt-list"
    ],
    observations: [ROLES.limitado, "Las guías de producción afectan kardex de insumos y productos elaborados."],
    screenshots: [SHOTS.listado],
    roles: ROLES.produccion,
  }),
  functionDoc({
    id: "prod-recetas-form",
    name: "Fichas de receta — registro",
    type: "form",
    route: "/produccion/clasificacion-recetas/recetas/nueva",
    locationPath: "Producción > Recetas > Nueva / Editar",
    generalDescription: "Define producto de salida, tipo PT/PEP, insumos con cantidades y merma. La explosión al producir usa estos datos para salidas de almacén.",
    prerequisites: [
      "Módulo Producción habilitado.",
      "Recetas y clasificación configuradas.",
      "Almacenes de insumo y PT definidos en guías."
    ],
    interfaceElements: [
      {
        "name": "Nombre y clasificación",
        "controlType": "Campo",
        "required": true,
        "editable": true,
        "automatic": false,
        "description": "Ubicación en jerarquía.",
        "behavior": ""
      },
      {
        "name": "Tipo de salida",
        "controlType": "Campo",
        "required": true,
        "editable": true,
        "automatic": false,
        "description": "Producto terminado o en proceso.",
        "behavior": ""
      },
      {
        "name": "Líneas de insumo",
        "controlType": "Grilla",
        "required": true,
        "editable": true,
        "automatic": false,
        "description": "Producto, cantidad por batch.",
        "behavior": ""
      },
      {
        "name": "Rendimiento",
        "controlType": "Campo",
        "required": true,
        "editable": true,
        "automatic": false,
        "description": "Cantidad elaborada por fórmula.",
        "behavior": ""
      }
    ],
    procedure: [
      "Nueva receta.",
      "Complete cabecera y clasificación.",
      "Agregue insumos.",
      "Defina rendimiento.",
      "Guarde."
    ],
    practicalExample: {
      "data": {
        "Receta": "Brownie",
        "Rendimiento": "24 porciones"
      },
      "steps": [
        "Cargue insumos",
        "Guarde"
      ]
    },
    validations: [
      "Al menos un insumo y producto de salida válido."
    ],
    expectedResult: [
      "Receta disponible en guías de producción."
    ],
    commonErrors: [
      {
        "error": "Receta sin insumos",
        "cause": "Ficha incompleta o producto inactivo.",
        "solution": "Complete la ficha de receta antes de producir."
      },
      {
        "error": "Stock insuficiente de insumo",
        "cause": "Saldo en almacén de explosión menor al requerido.",
        "solution": "Ingrese mercadería o reduzca cantidad a producir."
      }
    ],
    relatedFunctions: [
      "prod-recetas-list",
      "prod-report-insumo"
    ],
    observations: [ROLES.limitado, "Las guías de producción afectan kardex de insumos y productos elaborados."],
    screenshots: [SHOTS.formularioCompleto],
    roles: ROLES.produccion,
  }),
  functionDoc({
    id: "prod-guias-hub",
    name: "Guías de producción — inicio",
    type: "screen",
    route: "/produccion/guias",
    locationPath: "Producción > Guías de producción",
    generalDescription: "Seleccione guía de producto terminado o en proceso según el tipo de salida de sus recetas.",
    prerequisites: [
      "Módulo Producción habilitado.",
      "Recetas y clasificación configuradas.",
      "Almacenes de insumo y PT definidos en guías."
    ],
    interfaceElements: [
      {
        "name": "Tarjetas PT / PEP",
        "controlType": "Enlaces",
        "required": false,
        "editable": true,
        "automatic": true,
        "description": "Acceso a listados por tipo.",
        "behavior": ""
      }
    ],
    procedure: [
      "Producción → Guías.",
      "Elija Producto terminado o En proceso."
    ],
    practicalExample: "Turno mañana registra solo PT.",
    validations: [
      "Cada tipo lista recetas con salida compatible."
    ],
    expectedResult: [
      "Navegación al listado del tipo elegido."
    ],
    commonErrors: [
      {
        "error": "Receta sin insumos",
        "cause": "Ficha incompleta o producto inactivo.",
        "solution": "Complete la ficha de receta antes de producir."
      },
      {
        "error": "Stock insuficiente de insumo",
        "cause": "Saldo en almacén de explosión menor al requerido.",
        "solution": "Ingrese mercadería o reduzca cantidad a producir."
      }
    ],
    relatedFunctions: [
      "prod-guia-pt-list",
      "prod-guia-pep-list"
    ],
    observations: [ROLES.limitado, "Las guías de producción afectan kardex de insumos y productos elaborados."],
    screenshots: [SHOTS.vistaGeneral],
    roles: ROLES.produccion,
  }),
  functionDoc({
    id: "prod-guia-pt-list",
    name: "Guía producto terminado — listado",
    type: "list",
    route: "/produccion/guias/producto-terminado",
    locationPath: "Producción > Guías > Producto terminado",
    generalDescription: "Historial de guías PT: cantidades elaboradas, fecha y estado. Desde aquí crea nuevas producciones.",
    prerequisites: [
      "Módulo Producción habilitado.",
      "Recetas y clasificación configuradas.",
      "Almacenes de insumo y PT definidos en guías."
    ],
    interfaceElements: [
      {
        "name": "Filtros fecha",
        "controlType": "Filtros",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Acota listado.",
        "behavior": ""
      },
      {
        "name": "Nueva guía",
        "controlType": "Botón",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Formulario de captura por recetas.",
        "behavior": ""
      },
      {
        "name": "Tabla",
        "controlType": "Tabla",
        "required": false,
        "editable": true,
        "automatic": true,
        "description": "Guías confirmadas y borradores.",
        "behavior": ""
      }
    ],
    procedure: [
      "Abra listado PT.",
      "Filtre período.",
      "Nueva guía o edite existente."
    ],
    practicalExample: "Revisar producción del fin de semana.",
    validations: [
      "Edición limitada si ya afectó kardex."
    ],
    expectedResult: [
      "Listado de guías PT."
    ],
    commonErrors: [
      {
        "error": "Receta sin insumos",
        "cause": "Ficha incompleta o producto inactivo.",
        "solution": "Complete la ficha de receta antes de producir."
      },
      {
        "error": "Stock insuficiente de insumo",
        "cause": "Saldo en almacén de explosión menor al requerido.",
        "solution": "Ingrese mercadería o reduzca cantidad a producir."
      }
    ],
    relatedFunctions: [
      "prod-guia-pt-form",
      "prod-report-dashboard"
    ],
    observations: [ROLES.limitado, "Las guías de producción afectan kardex de insumos y productos elaborados."],
    screenshots: [SHOTS.listado],
    roles: ROLES.produccion,
  }),
  functionDoc({
    id: "prod-guia-pt-form",
    name: "Guía producto terminado — registro",
    type: "form",
    route: "/produccion/guias/producto-terminado/nueva",
    locationPath: "Producción > Guías > Producto terminado > Nueva",
    generalDescription: "Captura cantidades producidas por receta PT; al confirmar consume insumos y genera entrada de producto terminado en almacenes configurados.",
    prerequisites: [
      "Módulo Producción habilitado.",
      "Recetas y clasificación configuradas.",
      "Almacenes de insumo y PT definidos en guías."
    ],
    interfaceElements: [
      {
        "name": "Fecha y almacenes",
        "controlType": "Campo",
        "required": true,
        "editable": true,
        "automatic": false,
        "description": "Origen insumo y destino PT.",
        "behavior": ""
      },
      {
        "name": "Grilla recetas",
        "controlType": "Grilla",
        "required": true,
        "editable": true,
        "automatic": false,
        "description": "Cantidad elaborada por ficha.",
        "behavior": ""
      },
      {
        "name": "Explosión insumos",
        "controlType": "Panel",
        "required": false,
        "editable": true,
        "automatic": true,
        "description": "Vista previa de salidas.",
        "behavior": ""
      },
      {
        "name": "Confirmar",
        "controlType": "Botón",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Genera movimientos.",
        "behavior": ""
      }
    ],
    procedure: [
      "Nueva guía PT.",
      "Seleccione fecha y almacenes.",
      "Ingrese cantidades por receta.",
      "Revise explosión.",
      "Confirme.",
      "Valide kardex."
    ],
    practicalExample: {
      "data": {
        "Receta": "Ensalada mixta",
        "Cantidad": "50 kg"
      },
      "steps": [
        "Ingrese 50",
        "Confirme",
        "Revise salida insumos"
      ]
    },
    validations: [
      "Stock insumo suficiente.",
      "Cantidades positivas."
    ],
    expectedResult: [
      "Kardex actualizado: salida insumos, entrada PT."
    ],
    commonErrors: [
      {
        "error": "Receta sin insumos",
        "cause": "Ficha incompleta o producto inactivo.",
        "solution": "Complete la ficha de receta antes de producir."
      },
      {
        "error": "Stock insuficiente de insumo",
        "cause": "Saldo en almacén de explosión menor al requerido.",
        "solution": "Ingrese mercadería o reduzca cantidad a producir."
      }
    ],
    relatedFunctions: [
      "prod-guia-pt-list",
      "almacenes-kardex"
    ],
    observations: [ROLES.limitado, "Las guías de producción afectan kardex de insumos y productos elaborados."],
    screenshots: [SHOTS.formularioCompleto, SHOTS.confirmacion],
    roles: ROLES.produccion,
  }),
  functionDoc({
    id: "prod-guia-pep-list",
    name: "Guía producto en proceso — listado",
    type: "list",
    route: "/produccion/guias/producto-en-proceso",
    locationPath: "Producción > Guías > Producto en proceso",
    generalDescription: "Listado de guías PEP para etapas intermedias antes del producto terminado.",
    prerequisites: [
      "Módulo Producción habilitado.",
      "Recetas y clasificación configuradas.",
      "Almacenes de insumo y PT definidos en guías."
    ],
    interfaceElements: [
      {
        "name": "Listado y filtros",
        "controlType": "Tabla",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Igual que PT con tipo PEP.",
        "behavior": ""
      },
      {
        "name": "Nueva guía",
        "controlType": "Botón",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Alta de producción intermedia.",
        "behavior": ""
      }
    ],
    procedure: [
      "Guías → Producto en proceso.",
      "Consulte o cree guías."
    ],
    practicalExample: "Registro de masa madre como PEP.",
    validations: [
      "Solo recetas con salida en proceso."
    ],
    expectedResult: [
      "Guías PEP registradas."
    ],
    commonErrors: [
      {
        "error": "Receta sin insumos",
        "cause": "Ficha incompleta o producto inactivo.",
        "solution": "Complete la ficha de receta antes de producir."
      },
      {
        "error": "Stock insuficiente de insumo",
        "cause": "Saldo en almacén de explosión menor al requerido.",
        "solution": "Ingrese mercadería o reduzca cantidad a producir."
      }
    ],
    relatedFunctions: [
      "prod-guia-pep-form"
    ],
    observations: [ROLES.limitado, "Las guías de producción afectan kardex de insumos y productos elaborados."],
    screenshots: [SHOTS.listado],
    roles: ROLES.produccion,
  }),
  functionDoc({
    id: "prod-guia-pep-form",
    name: "Guía producto en proceso — registro",
    type: "form",
    route: "/produccion/guias/producto-en-proceso/nueva",
    locationPath: "Producción > Guías > Producto en proceso > Nueva",
    generalDescription: "Registra elaboración intermedia: consume insumos y aumenta stock de producto en proceso según receta.",
    prerequisites: [
      "Módulo Producción habilitado.",
      "Recetas y clasificación configuradas.",
      "Almacenes de insumo y PT definidos en guías."
    ],
    interfaceElements: [
      {
        "name": "Cabecera",
        "controlType": "Campo",
        "required": true,
        "editable": true,
        "automatic": false,
        "description": "Fecha y almacenes.",
        "behavior": ""
      },
      {
        "name": "Cantidades por receta PEP",
        "controlType": "Grilla",
        "required": true,
        "editable": true,
        "automatic": false,
        "description": "Grilla de captura.",
        "behavior": ""
      }
    ],
    procedure: [
      "Nueva guía PEP.",
      "Complete cantidades.",
      "Confirme.",
      "Verifique kardex PEP."
    ],
    practicalExample: "Producir relleno base para postres del día.",
    validations: [
      "Recetas deben ser tipo en proceso."
    ],
    expectedResult: [
      "Movimientos de insumo y PEP en kardex."
    ],
    commonErrors: [
      {
        "error": "Receta sin insumos",
        "cause": "Ficha incompleta o producto inactivo.",
        "solution": "Complete la ficha de receta antes de producir."
      },
      {
        "error": "Stock insuficiente de insumo",
        "cause": "Saldo en almacén de explosión menor al requerido.",
        "solution": "Ingrese mercadería o reduzca cantidad a producir."
      }
    ],
    relatedFunctions: [
      "prod-guia-pep-list",
      "prod-guia-pt-form"
    ],
    observations: [ROLES.limitado, "Las guías de producción afectan kardex de insumos y productos elaborados."],
    screenshots: [SHOTS.formularioCompleto],
    roles: ROLES.produccion,
  }),
  functionDoc({
    id: "prod-lineas",
    name: "Líneas de producción",
    type: "config",
    route: "/produccion/lineas",
    locationPath: "Producción > Líneas de producción",
    generalDescription: "Catálogo de líneas físicas o lógicas (horno, línea fría) para organizar capacidad cuando produccionLineasEnabled está activo.",
    prerequisites: [
      "Módulo Producción habilitado.",
      "Recetas y clasificación configuradas.",
      "Almacenes de insumo y PT definidos en guías."
    ],
    interfaceElements: [
      {
        "name": "Nombre de línea",
        "controlType": "Campo",
        "required": true,
        "editable": true,
        "automatic": false,
        "description": "Etiqueta operativa.",
        "behavior": ""
      },
      {
        "name": "Estado activo",
        "controlType": "Checkbox",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Disponible en planificación.",
        "behavior": ""
      }
    ],
    procedure: [
      "Producción → Líneas.",
      "Cree o edite líneas.",
      "Asigne en guías si la pantalla lo permite."
    ],
    practicalExample: "Línea «Horno 1» para panadería.",
    validations: [
      "Nombre único recomendado."
    ],
    expectedResult: [
      "Líneas disponibles para operación."
    ],
    commonErrors: [
      {
        "error": "Receta sin insumos",
        "cause": "Ficha incompleta o producto inactivo.",
        "solution": "Complete la ficha de receta antes de producir."
      },
      {
        "error": "Stock insuficiente de insumo",
        "cause": "Saldo en almacén de explosión menor al requerido.",
        "solution": "Ingrese mercadería o reduzca cantidad a producir."
      }
    ],
    relatedFunctions: [
      "prod-guia-pt-form"
    ],
    observations: [ROLES.limitado, "Las guías de producción afectan kardex de insumos y productos elaborados."],
    screenshots: [SHOTS.listado],
    roles: ROLES.produccion,
    isVisible: (ctx) => ctx.settings.produccionLineasEnabled,
  }),
  functionDoc({
    id: "prod-report-dashboard",
    name: "Dashboard de producción",
    type: "report",
    route: "/produccion/reportes/dashboard",
    locationPath: "Producción > Reportes > Dashboard",
    generalDescription: "Indicadores de volumen producido, tendencias y cumplimiento por período y producto.",
    prerequisites: [
      "Módulo Producción habilitado.",
      "Recetas y clasificación configuradas.",
      "Almacenes de insumo y PT definidos en guías."
    ],
    interfaceElements: [
      {
        "name": "Filtros fecha / producto",
        "controlType": "Filtros",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Parámetros del dashboard.",
        "behavior": ""
      },
      {
        "name": "Gráficos",
        "controlType": "Dashboard",
        "required": false,
        "editable": true,
        "automatic": true,
        "description": "Producción agregada.",
        "behavior": ""
      }
    ],
    procedure: [
      "Reportes → Dashboard.",
      "Filtre.",
      "Analice gráficos."
    ],
    practicalExample: "Comparar producción semanal vs plan.",
    validations: [
      "Basado en guías confirmadas."
    ],
    expectedResult: [
      "KPIs de producción visibles."
    ],
    commonErrors: [
      {
        "error": "Receta sin insumos",
        "cause": "Ficha incompleta o producto inactivo.",
        "solution": "Complete la ficha de receta antes de producir."
      },
      {
        "error": "Stock insuficiente de insumo",
        "cause": "Saldo en almacén de explosión menor al requerido.",
        "solution": "Ingrese mercadería o reduzca cantidad a producir."
      }
    ],
    relatedFunctions: [
      "prod-guia-pt-list",
      "prod-report-insumo"
    ],
    observations: [ROLES.limitado, "Las guías de producción afectan kardex de insumos y productos elaborados."],
    screenshots: [SHOTS.vistaGeneral],
    roles: ROLES.produccion,
  }),
  functionDoc({
    id: "prod-report-insumo",
    name: "Uso de insumo en recetas",
    type: "report",
    route: "/produccion/reportes/uso-insumo",
    locationPath: "Producción > Reportes > Uso de insumo",
    generalDescription: "Cuánto insumo consume cada receta o período de producción; apoya compras y costeo.",
    prerequisites: [
      "Módulo Producción habilitado.",
      "Recetas y clasificación configuradas.",
      "Almacenes de insumo y PT definidos en guías."
    ],
    interfaceElements: [
      {
        "name": "Filtro insumo o receta",
        "controlType": "Select",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Enfoque del reporte.",
        "behavior": ""
      },
      {
        "name": "Período",
        "controlType": "Fechas",
        "required": false,
        "editable": true,
        "automatic": false,
        "description": "Rango de fechas.",
        "behavior": ""
      },
      {
        "name": "Resultados",
        "controlType": "Tabla",
        "required": false,
        "editable": true,
        "automatic": true,
        "description": "Cantidades agregadas.",
        "behavior": ""
      }
    ],
    procedure: [
      "Abra Uso de insumo.",
      "Seleccione filtros.",
      "Exporte para compras si está disponible."
    ],
    practicalExample: "Proyección de harina para el mes.",
    validations: [
      "Incluye explosión de guías confirmadas."
    ],
    expectedResult: [
      "Consumo teórico y/o real por insumo."
    ],
    commonErrors: [
      {
        "error": "Receta sin insumos",
        "cause": "Ficha incompleta o producto inactivo.",
        "solution": "Complete la ficha de receta antes de producir."
      },
      {
        "error": "Stock insuficiente de insumo",
        "cause": "Saldo en almacén de explosión menor al requerido.",
        "solution": "Ingrese mercadería o reduzca cantidad a producir."
      }
    ],
    relatedFunctions: [
      "prod-recetas-form",
      "prod-report-dashboard"
    ],
    observations: [ROLES.limitado, "Las guías de producción afectan kardex de insumos y productos elaborados."],
    screenshots: [SHOTS.listado],
    roles: ROLES.produccion,
  }),
];
